module.exports = __webpack_public_path__ + "img/symbol_0.9f6a1713.png";